import { Element, useEditor, useNode } from "@craftjs/core";
import * as React from "react";
import type { Vendor } from "src/types";

import TopLevelFloatingOptions from "@/components/editor/block-outline/floating-options/top-level-floating-component";
import Text from "@/components/editor/primitives/text/text-component";
import {
  BlockBackgroundColorWrapper,
  BlockMaxWidthWrapper,
  BlockPaddingWrapper,
} from "@/components/editor/shared/block-wrapper";
import BoothsSettings from "@/components/editor/shared/expo/booths-settings/booths-settings-component";

import BoothCard from "../booth-card/booth-card-component";
import BoothsList from "./booths-list-component";

export const BOOTHS_LIST_ID = "booths-list";

type BoothsProps = {
  vendors: Vendor[];
};

export default function Booths(props: BoothsProps) {
  const {
    connectors: { connect },
    nodeId,
  } = useNode((node) => {
    return {
      nodeId: node.id,
    };
  });

  const { enabled } = useEditor((state) => ({
    enabled: state.options.enabled,
  }));

  return (
    <BlockBackgroundColorWrapper ref={connect} id={nodeId}>
      <BlockPaddingWrapper>
        <BlockMaxWidthWrapper>
          <div className="flex justify-center">
            <Element
              id="title"
              is={Text}
              text="Expo Booths"
              pattern="headingTwo"
            />
          </div>
          <Element id={BOOTHS_LIST_ID} is={BoothsList} canvas={enabled}>
            {props.vendors?.map((vendor) => (
              <BoothCard key={vendor.id} vendor={vendor} />
            ))}
          </Element>
        </BlockMaxWidthWrapper>
      </BlockPaddingWrapper>
    </BlockBackgroundColorWrapper>
  );
}

Booths.craft = {
  custom: {
    displayName: "Booths",
  },
  related: {
    leftOutlineOptions: TopLevelFloatingOptions,
    settings: () => BoothsSettings({ template: BoothCard }),
  },
};
